import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { NetworkService } from './network.service';

/**
 * Guard that forces the application to be online before activating a route
 * @returns A promise that resolves when the application is online
 */
export const forceOnlineGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
) => {
  const networkService = inject(NetworkService);
  await networkService.forceOnline();
  return true; // Always return true as we want to proceed after forcing online
};
